import { render, staticRenderFns } from "./TokenSale.vue?vue&type=template&id=264d7b66&"
import script from "./TokenSale.vue?vue&type=script&lang=js&"
export * from "./TokenSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports